const currentSymbol = Symbol("current");
const previousSymbol = Symbol("previous");
export {
  currentSymbol,
  previousSymbol
};
